import Vue from 'vue'

/**
 1: "Администратор",
 2: "Экспортер",
 3: "Диспетчер",
 4: "Перевозчик",
 5: "Менеджер"
 6: "СЕО",
**/
const access = {
  uploadFilesAuto: {
    1: true,
    3: true,
    4: true,
    6: true,
  },
  createDocAuto: {
    1: true,
    3: true,
    4: true,
    6: true,
  },
  uploadContract: {
    1: true,
    3: true,
    4: true,
    6: true,
  },
  tasks: {
    1: false,
    6: false,
  },
  sortActions: {
    1: true,
    6: true,
  },
  register_payment: {
    1: true,
    6: true,
  },
  chooseExporter: {
    1: true,
    6: true,
  },
  calcActions: {
    1: true,
    6: true,
  },
  additionalCompany: {
    1: true,
    3: true,
    6: true,
  },
  action_shipping_list: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  events: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  route_shipping_action: {
    1: true,
    2: true,
    3: false,
    5: true,
    6: true,
  },
  doPayDoc: {
    1: true,
    6: true,
  },
  shipping_stat: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  download_register: {
    1: true,
    2: true,
    3: false,
    5: true,
    6: true,
  },
  editAutosDrivers: {
    1: true,
    4: true,
    6: true,
  },
  global_search: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  action_set_reason: {
    1: true,
    2: true,
    6: true,
  },
  carriers: {
    1: true,
    2: true,
    3: false,
    6: true,
  },
  contragents: {
    1: false,
    6: false,
  },
  'Auto-list': {
    1: true,
    3: false,
    4: true,
    6: true,
  },
  'Driver-list': {
    1: true,
    3: false,
    4: true,
    6: true,
  },
  Flights: {
    1: true,
    2: true,
    3: false,
    4: true,
    5: true,
    6: true,
  },
  RegisterOfPayments: {
    1: true,
    6: true,
  },
  TableOfPayments: {
    1: true,
    6: true,
  },
  'Documents-list': {
    1: true,
    6: true,
  },
  'Responses-list': {
    1: true,
    6: true,
  },
  'Approvals-list': {
    1: true,
    6: true,
  },
  Users: {
    1: true,
    6: true,
  },
  'Managers-list': {
    1: true,
    2: true,
    6: true,
  },
  createBids: {
    1: true,
    2: true,
    6: true,
  },
  createResponse: {
    1: true,
    3: true,
    4: true,
    6: true,
  },
  see_master_approve_buttons: {
    1: true,
    6: true,
  },
  deleteResponse: {
    1: true,
    6: true,
  },
  delete_mobile_response: {
    1: true,
    2: true,
    3: true,
    4: true,
    6: true,
  },
  filter_menu: {
    1: true,
    6: true,
  },
  mobile_bids_edit: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  mobile_list_days: {
    1: true,
    2: true,
    3: true,
    4: true,
    6: true,
  },
  mobile_list_days_previous_period: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  load_files_not_required: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  shipping_bids_edit: {
    1: true,
    2: true,
    3: true,
    6: true,
  },
  editResponsePrice: {
    1: true,
    6: true,
  },
  send_notification: {
    1: true,
    6: true,
  },
  brutto_netto_ttn: {
    5: true,
  },
  brutto_netto_fact: {
    1: true,
    6: true,
  },
  see_master_approve_wrapper: {
    1: true,
    6: true,
  },
  doOverAkts: {
    1: true,
    6: true,
  },
  doImportPayBank: {
    1: true,
    6: true,
  },
  saveNomenclature: {
    1: true,
    5: true,
    6: true,
  },
  unknownFiles: {
    1: true,
    6: true,
  },
  unknownFilesMenu: {
    5: true,
  },
  changeDayStatus: {
    1: true,
    2: true,
    3: false,
    6: true,
  },
  editDayParams: {
    1: true,
    2: true,
    3: false,
    5: true,
    6: true,
  },
  deleteTTN: {
    1: true,
    6: true,
  },
  editResponseStatus: {
    1: true,
    6: true,
  },
  payments_bank_modal: {
    1: true,
    6: true,
  },
  edit_registry: {
    1: true,
    6: true,
  },
  responses_list_modal: {
    1: true,
    6: true,
  },
  addPowerOfAttorney: {
    1: true,
    6: true,
  },
  makeFlightsPayments: {
    1: true,
    6: true,
  },
  getEdmList: {
    1: true,
    6: true,
  },
  statisticByUser: {
    1: true,
    6: true,
  },
  flightsAccess: {
    1: true,
    2: true,
    3: true,
    4: true,
    5: false,
    6: true,
  },
}

function AccessFunction(action, userInfo = false) {
  if (access[action] === undefined) {
    return false
  }
  if (!userInfo || userInfo.user_type === undefined) {
    userInfo = this.$store.state.userProfile
  }

  return access[action][userInfo.user_type]
}

Vue.use({
  install(Vue) {
    Vue.prototype.$canAction = AccessFunction
  },
})
